import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByReferralComponent from '../../../../utils/ReportByReferralComponent/ReportByReferralComponent';
import { statisticsByReferral } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByReferralSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByReferral && statisticsByReferral.groupParamsSegment) || []}
        reportComponent={ReportByReferralComponent}
        translationKey="statisticsByReferral"
    />
);

export default StatisticsByReferralSegments;
